/* CSS */
import AuthHeader from './AuthHeader';
import styles from './LegalPage.module.css';

/*
 * Reusable scaffold for static legal documents (Terms of Use, Privacy Policy).
 * Content is supplied via `sections` — see src/data/legalData.js for the shape.
 */
const LegalPage = ({ title, effectiveDate, sections = [] }) => {
    return (
        <>
            {/* Branded header, no cancel button (public page) */}
            <AuthHeader showCancel={false} />

            <div className={styles.legalPage}>
                <h1 className={styles.title}>{title}</h1>
                {effectiveDate && (
                    <p className={styles.effectiveDate}>Last updated: {effectiveDate}</p>
                )}

                {sections.map((section, index) => (
                    <section key={index} className={styles.section}>
                        {section.heading && (
                            <h2 className={styles.heading}>{section.heading}</h2>
                        )}
                        {Array.isArray(section.body)
                            ? section.body.map((item, i) =>
                                Array.isArray(item)
                                    ? <ul key={i} className={styles.list}>
                                        {item.map((li, j) => <li key={j} className={styles.listItem}>{li}</li>)}
                                    </ul>
                                    : <p key={i} className={styles.paragraph}>{item}</p>
                            )
                            : <p className={styles.paragraph}>{section.body}</p>
                        }
                    </section>
                ))}
            </div>
        </>
    );
};

export default LegalPage;
